import { createSlice } from "@reduxjs/toolkit";

const customerSlice = createSlice({
    name:'customer',
    initialState:{
        customer:[]
    },
    reducers: {
        addCustomer : (state,action) => {
            // console.log("test ",action)
            //state.push(action.payload)
            state.customer = [...state.customer,action.payload]
        },
        // removeOccupation(){
        //     return state.occupation.filter((item)=> item.id != action.payload);
        // }
    }
});

export const { addCustomer } = customerSlice.actions;
export default customerSlice.reducer;